/* ===== CATI Pakistan — Site Data Store ===== */
import imgHeroTraining from '../assets/images/hero-training.png';
import imgHeroCampus from '../assets/images/hero-campus.png';
import imgGalleryClassroom from '../assets/images/gallery-classroom.png';
import imgEventConference from '../assets/images/event-conference.png';
import imgHeroFirefighting from '../assets/images/hero-firefighting.png';
import imgCampusAerial from '../assets/images/campus-aerial.png';
import imgLogoAnim from '../assets/images/CATI_logo_anim.gif';

export const IMAGE_MAP = {
  '/src/assets/images/hero-training.png': imgHeroTraining,
  'src/assets/images/hero-training.png': imgHeroTraining,
  '/src/assets/images/hero-campus.png': imgHeroCampus,
  'src/assets/images/hero-campus.png': imgHeroCampus,
  '/src/assets/images/gallery-classroom.png': imgGalleryClassroom,
  'src/assets/images/gallery-classroom.png': imgGalleryClassroom,
  '/src/assets/images/event-conference.png': imgEventConference,
  'src/assets/images/event-conference.png': imgEventConference,
  '/src/assets/images/hero-firefighting.png': imgHeroFirefighting,
  'src/assets/images/hero-firefighting.png': imgHeroFirefighting,
  '/src/assets/images/campus-aerial.png': imgCampusAerial,
  'src/assets/images/campus-aerial.png': imgCampusAerial,
  '/src/assets/images/CATI_logo_anim.gif': imgLogoAnim,
  'src/assets/images/CATI_logo_anim.gif': imgLogoAnim,
  './src/assets/images/CATI_logo_anim.gif': imgLogoAnim
};

export function resolveImageUrl(url) {
  if (!url) return imgHeroTraining;
  if (IMAGE_MAP[url]) return IMAGE_MAP[url];
  const cleanUrl = url.replace(/^\.\//, '');
  if (IMAGE_MAP[cleanUrl]) return IMAGE_MAP[cleanUrl];
  if (IMAGE_MAP['src/' + cleanUrl]) return IMAGE_MAP['src/' + cleanUrl];
  if (IMAGE_MAP['/src/' + cleanUrl]) return IMAGE_MAP['/src/' + cleanUrl];
  return url;
}

const STORAGE_KEY = 'cati_site_data';

/* ---------- DEFAULT DATA ---------- */
const DEFAULTS = {

  courses: [
    {
        "id": "c1",
        "title": "Aerodrome Area Control Procedural",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1VKH88h75Qd2hE34wgFTafqQiw4wKlL-5/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c2",
        "title": "New Global Reporting Format GRF",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1JA76U5yXcmASMAn7AH_MHrjRzqewMOZB/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c3",
        "title": "Aerodrome Control Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2026-06-01",
        "endDate": "2026-06-12",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1FDkRADyHiPuvMdczDwHBOeudnvFulE3P/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c4",
        "title": "Search and Rescue SAR Coordinator",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1yTTXt95-f2bxrI3sYTlBnTr5qCoBsUfU/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c5",
        "title": "Aerodrome Safeguarding and Obstacle Limitation Surfaces OLS",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/12NyJBro1qvPc0Jiqs-dvZVuuuHWlu8eD/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c6",
        "title": "Aircraft Operation at Uncontrolled Aerodromes",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1XYbENsh1bEu4eBaqX5MUnNN02W9DQho_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c7",
        "title": "Approach Control Procedural",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1mH7tMj8-ZuT0bSTRM9s9AmIj1qG2X6I3/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c8",
        "title": "Approach Control Surveillance",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1mUd02VZ9V_CbI3ihPCb_Wbz0YIvcO5ej/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c9",
        "title": "Area Approach Control Surveillance",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1jUWKp_iLlyj6hH8_oi5iWZJEsOVW_o2B/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c10",
        "title": "Area Control Procedural",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1wb6unskkqtL1qepXppsq2Syw2Fzhyo6K/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c11",
        "title": "Area Control Surveillance",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/14wRwWWRhGqO2lGdW13BHdBtAP8X7sSq_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c12",
        "title": "ATC Assistant Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1u2fwzwOKIauwCSX-TtEOebu6IZuN0fws/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c13",
        "title": "ATC Assistant Refresher Abridged",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11BRn3FpKsWkuRZdowfLKy1nMM4onrNOr/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c14",
        "title": "ATC Refresher Abridged",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1jZLlqq2ajaLKFSjogmo9WuM7Al8Sqtdc/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c15",
        "title": "Basic ATC Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1fUgb9qaMwxaanQeAKEVNuu05R5tbHLgU/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c16",
        "title": "Basic Search and Rescue",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Pp3z3VXA2EUrDc8fjYXaobID_FPRSky9/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c17",
        "title": "English Language Proficiency ELP Advanced Level for ATCOs",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1bzMazIMU5QCXQszsAh6QiBFxKc7YkX4z/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c18",
        "title": "English Language Proficiency Extended Level",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/15cGYIngtqeOL18A-W3pQjVsLs1BRZrka/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c19",
        "title": "Flight Procedure Design Conventional",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/18Rt_t5_EKy0JKv0F6kbEOJY7W-N2x36C/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c20",
        "title": "Flight Procedure Design PBN",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1j0n6GNcBxiNjrUTndittngNi0BgiIVGa/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c21",
        "title": "Global Reporting Format GRF",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ywqDt4w1B16HmrUMulQJQ2pXbEmyKCc0/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c22",
        "title": "Global Reporting Format GRF for Staff",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/154Fxyk3abiZCBOsHF1LiIRFcL0PzUpXB/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c23",
        "title": "Managing Aeronautical Information",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATS)",
        "code": "ANS (ATS)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/13K4gmsufFJXdEQ1santbmgA1NW-qHhYb/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c24",
        "title": "Air Traffic Management System Operation and Maintenance Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/18JDQmUKn3hwfby9fRuvb2riGOBEUTSIS/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c25",
        "title": "Surface Movement Radar (SMR) and Multi Lateration (MLAT) Systems O & M",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1_65clLuWhBk5oiFXEDdH_d24_6o-a-H5/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c26",
        "title": "ATSEP Data Processing and Networks Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1crz1rVdbktHujoqRPps26wyT8250DXER/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c27",
        "title": "VHF Extended Range System",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ajWFJ05N_HzombWDN3lz5yZU8Kdg8K9K/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c28",
        "title": "ATSEP General Electronics Systems Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1iB1sM45vypebtoDqkg4k4-EwMCqANMpm/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c29",
        "title": "ATSEP NAV AIDS Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1_2ao28QEpT8SsBC9blIQXC4JIM0c-rai/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c30",
        "title": "ATSEP Radar Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1nDtjWW0-6ock5Zixixea6cR3rvJeqko9/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c31",
        "title": "ATSEP Radio Communication Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2026-05-04",
        "endDate": "2026-05-08",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/10p0vhe2gzuOrBxWrqUPNfCqSkML23iWA/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c32",
        "title": "Automatic Dependent Surveillance Broadcast (ADS-B) Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1HY0ii4QrcTvORo54wYyj-vT1e17HqxyM/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c33",
        "title": "Automatic Fire Detection System (AFDS) Maintenance STP Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1EmyD6tOfL3_nQZtPr3ScY8zoemiLZJJU/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c34",
        "title": "Basic ATSEP Engineer Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1TnRQfg9G1vR8soqAch6tFemfbvdS8AcR/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c35",
        "title": "Basic ATSEP Refresher Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/12DhPMN09MLlKbd3gQ_kYRyTYwNnt1_8F/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c36",
        "title": "Basic ATSEP Technician Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1TQLVjs1JtRwxvJC-h6LmsdgpaB7db4oq/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c37",
        "title": "Course Catalogue Sample - ANS (ATSEP)",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2026-07-20",
        "endDate": "2026-07-31",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1xYZ8NKI9rWGOtCOFouSB0rlmn1627bkQ/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c38",
        "title": "Digital Voice Logging System ASC Marathon O & M Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/177K1SzeZEc3P7OfAmcIVP-MK0MwlbUa6/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c39",
        "title": "Eldis Mono Pulse Secondary Surveillance Radar O & M Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1qQH0chbfl3OxKFYVQzO_aJWuBHs3a1oF/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c40",
        "title": "Indra Mono Pulse Secondary Surveillance Radar (MSSR) O & M Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1LBfm9eKR3iKC5c07Vel8wJWIs73nPH9K/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c41",
        "title": "Indra Primary Surveillance Radar Operation & Maintenance Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/13kx43TvsjHLpHSG5x_o9W7nCwhwTPz7b/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c42",
        "title": "Networking Fundamentals Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1BqrCUV6Pp_g_neQzNxyIieEwGQe8aGi8/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c43",
        "title": "Networking Fundamentals Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1AQSf024KLwmRg_fEkM6_npG4v5R985YF/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c44",
        "title": "Non Directional Beacon (NDB) Maintenance Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1X90NGUiGHK8SZtx9oZdN_Wg6oMUjVJ_2/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c45",
        "title": "Selex Leonardo DVOR and DME Operation and Maintenance Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11KrqJHM5LoXRZlDXMBRNQCvlhnSFD7BC/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c46",
        "title": "Selex Leonardo Instrument Landing System (ILS) O & M Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (ATSEP)",
        "code": "ANS (ATSEP)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1b3qKPHmS1LG3Kri8bmR9tGYbYADY5sjn/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c47",
        "title": "ACSS Refresher Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/15BHRTvkG39GqEO8Fy20SFGyuM63i8ezn/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c48",
        "title": "Aeronautical Communication Service Supervisor (ACSS) Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1vWxKFciNiCUThoCQTDpMLrirhW_mjL4k/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c49",
        "title": "Aeronautical Fixed Service Operator",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1IvbLcYs4QU6Nm-LyobWfCnnIz_EXftOx/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c50",
        "title": "Aeronautical Fixed Service Operator Elementary Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1A7iKCK3eCJtyzUCHEgO1RlnuIrLycx6s/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c51",
        "title": "Aeronautical Mobile Service Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-01-12",
        "endDate": "2026-01-16",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1WEPn8-Z53l4eGGKrOY_Q9hBRjwgeNkjv/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c52",
        "title": "Aeronautical Mobile Service Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-01-12",
        "endDate": "2026-01-16",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1YxVeCF1bvylG_juUPH1-Tc9NTHPgwmcz/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c53",
        "title": "Aeronautical Mobile Service Refresher Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-01-12",
        "endDate": "2026-01-16",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1h9A347zBMQ7o0xMYBsjW97gk0XA4cSBR/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c54",
        "title": "Aeronautical Radio Frequency Spectrum Management (ARFSM)",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1xlra3Zjt99CnJsuF_PrKE5nJ76yxsTT8/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c55",
        "title": "Common Aeronautical Virtually Private Network (CRV) Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1_4UeiYb28Bo6TB2D6qdkHiO_zInZrc4M/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c56",
        "title": "Communication Operations (COO)",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1PbFfERGgtodau9ypNa1upYQeBMMii8rD/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c57",
        "title": "COO Refresher Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1emY8u_VKpwOpi-gEVHRccvzyD1Eny1WE/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c58",
        "title": "IDS AirNav AMHS Advance Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1nLiRdXCC5JI55El9Wafq5TN0P6-z0CD9/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c59",
        "title": "IDS AirNav AMHS CRONOS Database Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/12mzYqaOvFCiyocUnu94EEBMqghjME9Li/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c60",
        "title": "IDS AirNav AMHS CRONOS Database Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1AlJyo8SrqyeTzLPExDFC89zHoT5j5OG3/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c61",
        "title": "IDS AirNav AMHS UBIMEX Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ilz4siJEq_xTvxlO_-YaFv5NteCShqeC/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c62",
        "title": "IDS AirNav AMHS UBIMEX Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1au_b_8dXSWOx4WeeTE3fcPl8SP9RlkQh/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c63",
        "title": "IDS AMHS Orientation Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/19oFfXBF9TWcy9ufZFPgialyr2xVDQmtg/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c64",
        "title": "Safety Data Collection and Processing System (SDCPS) Software Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/12gvIc7AmKwqCHSDGFTDjBNLZMI_LSsgk/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c65",
        "title": "Telephone Operation and Courtesy Course",
        "school": "ans",
        "schoolLabel": "School of Air Navigation Services (CommOps)",
        "code": "ANS (CommOps)",
        "image": imgHeroTraining,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1YQNWI-aaC3Ii1F4M5Tf0ywlNuJvjicEk/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c66",
        "title": "Aerodrome Power Supply and Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1rE5Y7L0GYaXA5TZ4ux87bkMm6ADHMxyA/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c67",
        "title": "Airfield Lightning Operation and Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1wNlGPHVsmsicBNMMjrv78HtNlUKuowwl/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c68",
        "title": "Airfield Pavement Maintenance and Evaluation Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-04-06",
        "endDate": "2026-04-10",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1MDya5MPbqnN_EoFvhQBcpQVaLA1f7iD7/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c69",
        "title": "Barracuda LFCT Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-02",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1jbfDuu_gLvajlA-_7rnbqxBEUIffmtUt/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c70",
        "title": "Basic Electrical and Mechanical Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1LZv8-9KiLJSdMUXdZWRp6uufFH34gMuS/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c71",
        "title": "Basic Engineering Services Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-06-08",
        "endDate": "2026-06-19",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1l-9eM1qYyB8X3JVLkH05GkV-PQNMN8QP/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c72",
        "title": "Civil Trade Official Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1aFeCjfLEEmcUMGJivs8Q6ays6PTY8Adb/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c73",
        "title": "Engineering Estimation Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-06-08",
        "endDate": "2026-06-19",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1NW2IdBXHOdHnsN3yLwxd6KhPkn0wzqE8/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c74",
        "title": "FIDIC Contracts Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-08-17",
        "endDate": "2026-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Imf5St55YiGF9lAS5Y8sCKvlYpo5OHTv/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c75",
        "title": "HVAC Operation and Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1jB2OH9OIgYNzC3uGuZ_lZ7FcJfVNo5J7/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c76",
        "title": "Motor Transport Driver Refresher Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11x6RxNi2HrzDSQiuHO3XawjEMmDxS6V7/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c77",
        "title": "Passenger Boarding Bridges Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-03-30",
        "endDate": "2026-04-04",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/19YnSbCCYolBgR2i4P1RQ9MD4L7zh2zQ_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c78",
        "title": "Skiddometer Mu Metter Operation and Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1rNLTGHl94muCJFqPBoX0LsOXhcVKaeMM/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c79",
        "title": "Standards and Recommended Practices for Aerodromes Annex 14",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/16AEIOvCes4GGo4QHeXKI780CyLTxCKsN/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c80",
        "title": "Striker Oshkosh Maintenance Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-02",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1pJ5J9-lyEwgaZGNCMvcj5goO2MVgSLvL/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c81",
        "title": "Underground Cable Faults Repair Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Engineering)",
        "code": "APS (ES)",
        "image": imgHeroFirefighting,
        "startDate": "2026-05-04",
        "endDate": "2026-05-15",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1IB-TmKhD_Dw1Ys-MfOpEIa7FH6HT0xxR/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c82",
        "title": "Aerodrome Operation Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-06-01",
        "endDate": "2026-06-12",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1UXcyrnuO3RL0grwr62xiaoCag9kaMAVc/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c83",
        "title": "Air Cargo and Mail Security Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1AtbiDd9s3JC9JeNd1uc_ZtXEoFk5ymd_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c84",
        "title": "Airside Inspector Staff Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-07-13",
        "endDate": "2026-07-17",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1TseoKV5g98lnwdmZHd-kn5wIHHn4jvbN/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c85",
        "title": "Airside Safety Awareness Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-01-05",
        "endDate": "2026-01-09",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1u3dTOdwgHwLv8tHa4YNDJaFE8sBemjjO/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c86",
        "title": "Aviation Security National Inspector Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-01-19",
        "endDate": "2026-01-23",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Hxh7dYcroSD6e8Ue7_cbMis6vwIfXBma/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c87",
        "title": "AVSEC Instructor Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1iJj31cTDbr0d9FTnApcFawaUKexlOKJE/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c88",
        "title": "Basic Aviation Security Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-01-19",
        "endDate": "2026-01-23",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Mz-vUHsE-gI7UE-JZ1JFzLq-0LtIXjiM/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c89",
        "title": "Crisis Management Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-04-20",
        "endDate": "2026-04-24",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11ChlWgBCIhp2wS7qYVdWD900tqUNHO9T/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c90",
        "title": "Facilitation and Hospitality Management Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-03-30",
        "endDate": "2026-04-10",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Fvj_oXmKNQr8eUlLDA1RmnD7utsbmFp-/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c91",
        "title": "Facilitation and Hospitality Management Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (Security & Ops)",
        "code": "APS (Misc)",
        "image": imgHeroCampus,
        "startDate": "2026-03-30",
        "endDate": "2026-04-10",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1avbD6UrasVPQGM_4Y3D1jTLi8p0Jq_DC/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c92",
        "title": "Aerodrome Fire Fighter Refresher",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-04-20",
        "endDate": "2026-04-24",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1CUA1SqK25pCGxaYEwdVlqNoUI7owH8L_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c93",
        "title": "Aircraft Marshaling Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-08-31",
        "endDate": "2026-09-04",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11U7lkomJCszbuiq0cOjR7vacbypaLY0C/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c94",
        "title": "Basic Aerodrome Fire Fighter Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-02-06",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ETVgMbn7T5brWfBVEvHakvve_5n-u57g/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c95",
        "title": "Basic Aerodrome Fire Fighting Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-02-06",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11XoK3uKk8RjuAEoJmiHFX3PYCE6OwpMF/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c96",
        "title": "Basic Bird Shooter Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1dS_-GSBSmIPWSsFKUVUaVtNuEmoDVTqW/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c97",
        "title": "Basic SVD Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1NmZzyyij9PuRZz42FOLwiC0OodjCz8sa/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c98",
        "title": "Breathing Apparatus Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-03-30",
        "endDate": "2026-04-17",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1fme3AcIHsuyBLLDS7I-TfdYvV1C2u9JT/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c99",
        "title": "Fire Fighting Course Corporate Sector 3",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-26",
        "endDate": "2026-01-30",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ugmpcGqN6Og0KzgQNS1bDOenZgY1WPMb/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c100",
        "title": "Fire Investigation Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-11-30",
        "endDate": "2026-12-11",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1YxI4OL822r0Wv32Fvp2bFtWVXOtZzc33/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c101",
        "title": "Fire Officers Refresher Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-08-03",
        "endDate": "2026-08-07",
        "durationWeeks": 2,
        "pricePKR": 45000,
        "priceUSD": 160,
        "onePagerLink": "https://docs.google.com/document/d/1RrXhybbJAlvJyDPCTnrLv1mDwgm4tMgi/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c102",
        "title": "Fire Prevention Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-09",
        "endDate": "2026-02-27",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/14vkO-Q9raNr_VQklrpk2A7T94W-V7_ow/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c103",
        "title": "Incident Command and Control Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1sHoRm7BXQYXO8ktFQdPTAM4T3DUSKBkc/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c104",
        "title": "Junior Fire Officers Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-09-28",
        "endDate": "2026-10-30",
        "durationWeeks": 2,
        "pricePKR": 45000,
        "priceUSD": 160,
        "onePagerLink": "https://docs.google.com/document/d/1KjpDoaOqVjNNuJZpoOPzpOOmeEVw7bRO/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c105",
        "title": "Marshaling Refresher Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/10tw_t4pBC87vduzxLxEvuobXu2wOoWEv/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c106",
        "title": "Rescue and First Aid Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-08",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Sz4WAM04ohKJ7Rz47FtNlZHL_zSvE3WE/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c107",
        "title": "Senior Aerodrome Fire Fighter Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-02-06",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11jfgxenaMl92AicVd5MpSd8v6nUqom9A/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c108",
        "title": "Senior Fire Officers Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-01-05",
        "endDate": "2026-02-06",
        "durationWeeks": 2,
        "pricePKR": 45000,
        "priceUSD": 160,
        "onePagerLink": "https://docs.google.com/document/d/1SVIWaO7gYVAByFxGUYLNQNcrtAgrhqpo/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c109",
        "title": "Special Vehicle Driver Refresher Course",
        "school": "aps",
        "schoolLabel": "School of Airport Services (RFFS)",
        "code": "APS (RFFS)",
        "image": imgHeroFirefighting,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1O4nigYt2CfQRif0sC3FUAh292rJTnGu9/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c110",
        "title": "Aviation Cyber Security Management Compliance",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-09-14",
        "endDate": "2026-09-18",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/16r9keE3My3au-UOY6e4NeTugBp_cI97p/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c111",
        "title": "Aviation Management Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-01-12",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1G7Th-K1k8nqvdA5XgO5MCjy3_OI3fTz_/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c112",
        "title": "Basic Course for Management System Standards (ISO/SMS)",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-05-11",
        "endDate": "2026-05-22",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1SyD9fPgMpS8z-zPYd8GE_tKk2UxYj0C9/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c113",
        "title": "Basic Logistics Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1oi7rLFZMZ3J4jAiAmMcDFObMouYRnhqd/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c114",
        "title": "Basic Logistics Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1caw-S-fie8npNz60kh5hF3iZvOkbTYJk/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c115",
        "title": "Basic Office Organization Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-01-05",
        "endDate": "2026-01-16",
        "durationWeeks": 3,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1qg8yx-S5g-Ic-OMOnnyNKKJqeQVBgVQe/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c116",
        "title": "Emotional Intelligence Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-01-26",
        "endDate": "2026-01-30",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1jEPnHeiz2tgc6pmorjNGZpWEdOWcNyqS/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c117",
        "title": "EPADS Functional Training Wave",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1MVQsjAtw2NfQwIkYRPGq7mlpGFxgAKvF/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c118",
        "title": "Examination Techniques Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-12-07",
        "endDate": "2026-12-18",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1277CkVDCSzhqJUgn-QDL09IAgScBfN0i/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c119",
        "title": "Finance for Non-Financial Managers",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2025-08-03",
        "endDate": "2025-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1NoKTesfL-sajSwn4mBxlaIbhrOfJ5bsC/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c120",
        "title": "Foundation of Ethics in Aviation",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-08-03",
        "endDate": "2026-08-07",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1v49Dyod6EKO9x1mgKFlqYEUl1PxgpMxa/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c121",
        "title": "Instructor Training Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1HLyo32mpaPT-ztpooN6xFEfxy7U-kGvn/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c122",
        "title": "Instructor Training Refresher Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-02-16",
        "endDate": "2026-02-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1AmelVZW4C_EW51ouRG0FWCvvUbUFlBEG/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c123",
        "title": "Leadership Development Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-02-09",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1TIT9RWwAblYDLTQkybdQDy7PuAyPXjHj/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c124",
        "title": "PCAA Information System Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-05-11",
        "endDate": "2026-05-22",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1PQls1858xSJ8mLeFnUyoBk78--mBktsJ/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c125",
        "title": "PCAA Information System Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-05-11",
        "endDate": "2026-05-22",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11e0qxMDBQ5xU2zQ1RN7HjcqD_cHrzntw/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c126",
        "title": "Personal Effectiveness Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-05-04",
        "endDate": "2026-05-08",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1WAWPXc_-KDrEZwu_hYUWqFWAF3Bv3PQh/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c127",
        "title": "PPRA Rules and Contract Management",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-07-27",
        "endDate": "2026-07-31",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1o7MSkAqE_qIPCDyIX-E3LDjXz0kHh_Ig/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c128",
        "title": "Superintendent Development Course",
        "school": "mgmt",
        "schoolLabel": "School of Aviation Management",
        "code": "AVN MGT",
        "image": imgGalleryClassroom,
        "startDate": "2026-02-09",
        "endDate": "2026-02-13",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1PCirv3Fjf22BVLs1Z-KoBzUJWcZBZn3o/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c129",
        "title": "Aeronautical Studies Safety Assessment Course",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-01-12",
        "endDate": "2026-01-16",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1OQ3xN3GytnaBxpopNa9HCTiUWofHwcKe/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c130",
        "title": "Air Cargo Regulatory Framework and Compliance",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-06-01",
        "endDate": "2026-06-05",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1wPvblGHyVKhQLmyojJtEaprOXReXWZc5/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c131",
        "title": "Air Passengers Rights Course",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-03-30",
        "endDate": "2026-04-04",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ZKuZh_ZYwGQKdCDi31VjKAtEWJ93sZ27/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c132",
        "title": "Airport Economics Course",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-01-19",
        "endDate": "2026-01-23",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/11ajb-b12z8_VAQ-b9K7xtzPYciwMP3_X/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c133",
        "title": "Airport Marketing",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-08-17",
        "endDate": "2026-08-21",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1o4WoiReqMMqjPIXfOLfih957JE0xV0Bv/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c134",
        "title": "Annex 14 Application and Its Requirements",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-11-16",
        "endDate": "2026-11-20",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1uuahUUBkDgEaGuedsimMj_RUd4m8xCL3/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c135",
        "title": "Audit Technique Course – Generic",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-01-05",
        "endDate": "2026-01-09",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1WmdVeTYu4Vsk3RkT_iispyMHJodA_ItP/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c136",
        "title": "Aviation Climate Change",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-10-05",
        "endDate": "2026-10-09",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1ebeMMxAMqLG7MW_yl40orHITzc1rZzV6/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c137",
        "title": "Aviation Economics Course",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-01-19",
        "endDate": "2026-01-23",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/15g78_69bN2XfFjGJ-heedsRVBcVMoT5V/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c138",
        "title": "Flight Procedure Design Regulatory Framework",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-06-01",
        "endDate": "2026-06-05",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/10V_JTfJ9NpwrVxJLJRVStefFhv4hP0H4/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c139",
        "title": "International Air Law",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-05-04",
        "endDate": "2026-05-08",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1Nky6anFst9lwFDxJ6_ipm14wly6K1bx3/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    },
    {
        "id": "c140",
        "title": "Managing Compliance with ICAO SARPs",
        "school": "reg",
        "schoolLabel": "School of Regulatory Services",
        "code": "REGULATORY",
        "image": imgHeroCampus,
        "startDate": "2026-05-18",
        "endDate": "2026-05-22",
        "durationWeeks": 2,
        "pricePKR": 35000,
        "priceUSD": 125,
        "onePagerLink": "https://docs.google.com/document/d/1y2YihyrIa7Rc5f8BMl2Qv4oiBxAxzvZf/edit?usp=drive_link&ouid=111446433743627867617&rtpof=true&sd=true"
    }
],

  gallery: [
    { id: 'g1', src: imgHeroCampus, alt: 'CATI campus building Hyderabad', category: 'campus' },
    { id: 'g2', src: imgHeroTraining, alt: 'Air traffic control training classroom', category: 'training' },
    { id: 'g3', src: imgHeroFirefighting, alt: 'Airport firefighting drill at CATI', category: 'training' },
    { id: 'g4', src: imgCampusAerial, alt: 'CATI campus aerial view', category: 'campus' },
    { id: 'g5', src: imgEventConference, alt: 'CATI CPD conference event', category: 'events' },
    { id: 'g6', src: imgGalleryClassroom, alt: 'Aviation management classroom at CATI', category: 'training' }
  ],

  news: [
    {
      id: 'n1', title: '12th Continuing Professional Development (CPD)',
      date: 'March 2024', expiryDate: '2026-12-31', active: true, isSplash: true, image: imgEventConference,
      description: 'CATI hosted the 12th CPD session bringing together aviation professionals for knowledge sharing and professional growth.'
    },
    {
      id: 'n2', title: '11th ESP (Experience Sharing Platform)',
      date: 'June 2024', expiryDate: '2026-12-31', active: true, image: imgGalleryClassroom,
      description: 'The 11th Experience Sharing Platform facilitated cross-departmental learning and best-practice exchanges.'
    },
    {
      id: 'n3', title: '10th ESP (Experience Sharing Platform)',
      date: 'March 2024', expiryDate: '2026-12-31', active: true, image: imgHeroCampus,
      description: 'Aviation professionals gathered for the 10th ESP to share operational experiences and safety insights.'
    }
  ],

  heroSlides: [
    { type: 'video', src: './CATI.mp4', alt: 'CATI Campus Video' },
    { src: imgHeroCampus, alt: 'CATI Campus at Hyderabad' },
    { src: imgHeroTraining, alt: 'Air traffic control training at CATI' },
    { src: imgHeroFirefighting, alt: 'Airport firefighting training drill at CATI' }
  ],

  schools: [
    {
      id: 'ans', icon: 'fa-solid fa-tower-broadcast',
      title: 'School of Air Navigation Services (ANS)',
      description: "Training the professionals who guide aircraft safely through Pakistan's airspace. ANS equips air traffic controllers and navigation engineers with state-of-the-art radar simulation and real-world procedure expertise.",
      link: 'schools.html#ans'
    },
    {
      id: 'aps', icon: 'fa-solid fa-fire-extinguisher',
      title: 'School of Airport Services (APS)',
      description: "Preparing emergency response teams, airfield engineers, and airport operations personnel to maintain peak safety standards across Pakistan's airports.",
      link: 'schools.html#aps'
    },
    {
      id: 'reg', icon: 'fa-solid fa-gavel',
      title: 'School of Regulatory Services (REG)',
      description: 'Fostering compliance with International Civil Aviation Organization (ICAO) Standards and Recommended Practices (SARPs) across civil aviation regulations.',
      link: 'schools.html#reg'
    },
    {
      id: 'mgmt', icon: 'fa-solid fa-briefcase',
      title: 'School of Aviation Management (AVM)',
      description: 'Developing strategic executive skills, corporate governance, legal frameworks, and management systems standards for aviation leadership.',
      link: 'schools.html#mgmt'
    }
  ],

  stats: [
    { value: 44, suffix: '+', label: 'Years of Training' },
    { value: 100, suffix: '+', label: 'Courses Annually' },
    { value: 4, suffix: '', label: 'Specialised Schools' },
    { value: 100, suffix: '', label: 'Acre Campus' }
  ],

  about: {
    eyebrow: 'About CATI',
    title: "Pakistan's Centre of Aviation Training",
    paragraph1: "Established in 1982 as the training arm of Pakistan's Civil Aviation Authority, CATI stands as Pakistan's dedicated aviation training institute, now operating under the Pakistan Airports Authority. With ICAO TRAINAIR PLUS certification and a 100-acre campus equipped with decommissioned aircraft for practical exercises, CATI has been shaping aviation professionals for over four decades.",
    paragraph2: "Our four specialised schools cover air navigation, airport services, regulatory functions, and aviation management — offering comprehensive ab-initio, refresher, and advanced training programmes for aviation professionals across Pakistan and internationally.",
    image: imgCampusAerial
  },

  contact: {
    address: 'Civil Aviation Training Institute (CATI), Adjacent to Hyderabad Airport, Hyderabad, Sindh, Pakistan',
    phone: '+92 22 9260310 to 19',
    phoneTel: '+922292603100',
    email: 'AdlD.Academics@paa.gov.pk',
    hours: 'Monday – Friday: 8:00 AM – 4:00 PM\nSaturday – Sunday: Closed',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.589886742502!2d68.3609482!3d25.3172075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x394c6fc3290ab9b9%3A0x51b0a67bd3d3fb2a!2sCivil%20Aviation%20Training%20Institute(CATI)!5e0!3m2!1sen!2spk!4v1700000000000!5m2!1sen!2spk'
  },

  enquiryFields: [
    { id: 'f1', name: 'fullName', label: 'Full Name', type: 'text', required: true, visible: true, placeholder: 'John Doe', halfWidth: true },
    { id: 'f2', name: 'email', label: 'Email Address', type: 'email', required: true, visible: true, placeholder: 'john@example.com', halfWidth: true },
    { id: 'f3', name: 'phone', label: 'Phone Number', type: 'tel', required: true, visible: true, placeholder: '+92 300 1234567', halfWidth: true },
    { id: 'f4', name: 'organization', label: 'Organization', type: 'text', required: false, visible: true, placeholder: 'Company / Institute name', halfWidth: true },
    { id: 'f5', name: 'schoolInterest', label: 'School / Area of Interest', type: 'select', required: false, visible: true, halfWidth: true,
      options: [
        { value: '', label: 'Select a school...' },
        { value: 'ans', label: 'School of Air Navigation Services' },
        { value: 'aps', label: 'School of Airport Services' },
        { value: 'reg', label: 'School of Regulatory Services' },
        { value: 'mgmt', label: 'School of Aviation Management' }
      ]
    },
    { id: 'f6', name: 'subject', label: 'Subject', type: 'text', required: false, visible: true, placeholder: 'Course registration / Corporate enquiry', halfWidth: true },
    { id: 'f7', name: 'message', label: 'Message', type: 'textarea', required: true, visible: true, placeholder: 'Describe your training inquiry...', halfWidth: false }
  ],

  enquiryEmail: 'AdlD.Academics@paa.gov.pk',

  resendApiKey: 're_ckwvuLcY_JuTAnEaG6fUU6iReiaWWQ2H3',

  adminAccount: {
    usernameHash: '8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918',
    passwordHash: '1813d05a224867ed3c2525ba1e922e3072d73eafd20cba060ba37d8b2f627d31',
    email: 'oicit.cati@paa.gov.pk'
  },

  emailjsConfig: {
    serviceId: '',
    templateId: '',
    publicKey: ''
  },

  auditLogs: [
    { timestamp: new Date().toISOString(), action: 'SYSTEM_INIT', details: 'CATI CMS & Security System initialized.' }
  ],

  facilities: [
    {
      id: 'f_medical',
      name: 'Medical Center',
      category: 'Health & Wellness',
      tagline: 'A modern, well-equipped campus health facility built to care for you.',
      description: 'An on-campus medical center staffed by qualified doctors and paramedical personnel to provide primary healthcare, emergency first aid, routine health checkups, and a full dispensary.',
      icon: 'fa-stethoscope',
      themeClass: 'theme-medical',
      status: 'Qualified Staff',
      operatingHours: 'Mon–Sat: 8:00 AM – 6:00 PM',
      tags: ['Qualified Doctors', 'Dispensary', 'Emergency Aid', 'Referral Services'],
      photos: [
        {
          id: 'p_med_1',
          title: 'Medical Center — Main Reception & Waiting Area',
          caption: 'Spacious and welcoming reception area providing patient registration and comfortable seating for trainees and staff.',
          image: imgHeroCampus,
          icon: 'fa-hospital',
          color: 'linear-gradient(135deg, #0b4f6c, #012a4a)',
          active: true
        },
        {
          id: 'p_med_2',
          title: 'Outpatient Department (OPD)',
          caption: 'Equipped consultation rooms where qualified medical officers conduct daily examinations and routine health checkups.',
          image: imgGalleryClassroom,
          icon: 'fa-user-doctor',
          color: 'linear-gradient(135deg, #0284c7, #0369a1)',
          active: true
        },
        {
          id: 'p_med_3',
          title: 'Dispensary & Pharmacy',
          caption: 'On-site medical dispensary stocked with essential pharmaceuticals and emergency medications.',
          image: imgEventConference,
          icon: 'fa-pills',
          color: 'linear-gradient(135deg, #059669, #047857)',
          active: true
        },
        {
          id: 'p_med_4',
          title: 'Diagnostic Lab',
          caption: 'Basic diagnostic and pathology testing equipment for rapid blood work and screening.',
          image: imgHeroTraining,
          icon: 'fa-vials',
          color: 'linear-gradient(135deg, #d97706, #b45309)',
          active: true
        },
        {
          id: 'p_med_5',
          title: 'Emergency & Ambulance Response',
          caption: '24/7 emergency response unit with ambulance service linked directly to Hyderabad specialty hospitals.',
          image: imgCampusAerial,
          icon: 'fa-truck-medical',
          color: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
          active: true
        }
      ]
    },
    {
      id: 'f_library',
      name: 'Library & Resource Center',
      category: 'Learning Resources',
      tagline: 'Comprehensive aviation literature, e-databases, and quiet study environments.',
      description: 'A comprehensive academic library housing over 15,000 print and digital resources including specialized aviation textbooks, ICAO publications, technical manuals, research journals, and access to international e-databases.',
      icon: 'fa-book-open',
      themeClass: 'theme-library',
      status: 'Available',
      operatingHours: 'Mon–Sat: 8:00 AM – 8:00 PM',
      tags: ['15,000+ Volumes', '40+ Workstations', 'High-Speed Wi-Fi', 'Study Rooms'],
      photos: [
        {
          id: 'p_lib_1',
          title: 'Main Reading Hall & Stacks',
          caption: 'Quiet, air-conditioned reading room with extensive aviation stacks and study carrels.',
          image: imgGalleryClassroom,
          icon: 'fa-book',
          color: 'linear-gradient(135deg, #0b2c4d, #1a5fa6)',
          active: true
        },
        {
          id: 'p_lib_2',
          title: 'Digital E-Library Computer Lab',
          caption: '40 high-speed computer terminals providing access to ICAO e-library and academic databases.',
          image: imgHeroTraining,
          icon: 'fa-desktop',
          color: 'linear-gradient(135deg, #1e3a8a, #3b82f6)',
          active: true
        },
        {
          id: 'p_lib_3',
          title: 'Group Study & Discussion Rooms',
          caption: 'Private rooms for group projects, research collaboration, and exam preparation.',
          image: imgEventConference,
          icon: 'fa-users',
          color: 'linear-gradient(135deg, #047857, #10b981)',
          active: true
        }
      ]
    },
    {
      id: 'f_cafeteria',
      name: 'Cafeteria & Dining',
      category: 'Dining Services',
      tagline: 'Hygienic, affordable, and nutritious dining in an air-conditioned setting.',
      description: 'A spacious, air-conditioned campus cafeteria serving freshly prepared, hygienic, and affordable meals three times a day. Featuring a capacity of 300+ seats, a dedicated coffee corner, and weekly rotating menus.',
      icon: 'fa-utensils',
      themeClass: 'theme-cafeteria',
      status: 'Available',
      operatingHours: 'Daily: 7:30 AM – 9:00 PM',
      tags: ['300+ Capacity', 'Fresh Daily Meals', 'Fully Air-Conditioned', 'Coffee Corner'],
      photos: [
        {
          id: 'p_caf_1',
          title: 'Main Dining Hall',
          caption: 'Spacious AC seating for over 300 trainees and faculty members.',
          image: imgHeroCampus,
          icon: 'fa-chair',
          color: 'linear-gradient(135deg, #7c2d12, #b45309)',
          active: true
        },
        {
          id: 'p_caf_2',
          title: 'Express Café & Refreshments',
          caption: 'Specialty teas, coffees, snacks, and fresh juices available throughout the day.',
          image: imgEventConference,
          icon: 'fa-mug-hot',
          color: 'linear-gradient(135deg, #b45309, #d97706)',
          active: true
        }
      ]
    },
    {
      id: 'f_masjid',
      name: 'Campus Masjid',
      category: 'Spiritual & Worship',
      tagline: 'Serene place of worship for five daily prayers and Friday congregations.',
      description: 'A serene and spacious on-campus Masjid providing a dedicated place of worship for trainees, faculty, and staff. Complete with modern wudu (ablution) facilities and separate prayer sections.',
      icon: 'fa-mosque',
      themeClass: 'theme-masjid',
      status: 'Open 24/7',
      operatingHours: 'Open 24 Hours / 7 Days',
      tags: ['5 Daily Prayers', '200+ Capacity', 'Wudu Area', 'Sound System'],
      photos: [
        {
          id: 'p_mas_1',
          title: 'Main Prayer Hall',
          caption: 'Beautiful carpeted prayer hall accommodating 200+ worshippers for daily prayers.',
          image: imgHeroCampus,
          icon: 'fa-mosque',
          color: 'linear-gradient(135deg, #1a3a2a, #1e8e3e)',
          active: true
        },
        {
          id: 'p_mas_2',
          title: 'Wudu & Ablution Complex',
          caption: 'Clean, well-maintained ablution facilities with continuous water supply.',
          image: imgGalleryClassroom,
          icon: 'fa-hands-wash',
          color: 'linear-gradient(135deg, #065f46, #059669)',
          active: true
        }
      ]
    },
    {
      id: 'f_sports',
      name: 'Sports Complex & Gym',
      category: 'Sports & Recreation',
      tagline: 'Comprehensive indoor and outdoor athletic facilities for wellness and teamwork.',
      description: 'A fully equipped sports complex supporting outdoor and indoor athletics including cricket grounds, football field, basketball court, badminton courts, and table tennis, alongside a modern gymnasium.',
      icon: 'fa-person-running',
      themeClass: 'theme-sports',
      status: 'Available',
      operatingHours: 'Daily: 6:00 AM – 9:00 PM',
      tags: ['Cricket & Football', 'Fitness Gym', 'Indoor Games', 'Sports Events'],
      photos: [
        {
          id: 'p_spo_1',
          title: 'Cricket & Athletics Ground',
          caption: 'Full-sized manicured ground hosting institute tournaments and evening matches.',
          image: imgCampusAerial,
          icon: 'fa-baseball-bat-ball',
          color: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
          active: true
        },
        {
          id: 'p_spo_2',
          title: 'Fitness Gymnasium',
          caption: 'Cardio and weight training equipment for student physical fitness.',
          image: imgHeroFirefighting,
          icon: 'fa-dumbbell',
          color: 'linear-gradient(135deg, #1d4ed8, #3b82f6)',
          active: true
        }
      ]
    },
    {
      id: 'f_smart',
      name: 'Smart Campus Infrastructure',
      category: 'Technology & Innovation',
      tagline: 'IoT-enabled smart learning environment connected to PITB cloud systems.',
      description: 'A modern digital campus environment featuring campus-wide high-speed Wi-Fi, multimedia smart classrooms, biometric access control, smart attendance logging, and seamless LMS integration.',
      icon: 'fa-microchip',
      themeClass: 'theme-smart',
      status: 'Always On',
      operatingHours: 'Active 24/7',
      tags: ['Fiber Wi-Fi', 'Smart Boards', 'Biometric Access', 'LMS Integrated'],
      photos: [
        {
          id: 'p_sma_1',
          title: 'Interactive Smart Classrooms',
          caption: 'Multimedia projectors, interactive whiteboards, and high-speed Wi-Fi connectivity.',
          image: imgGalleryClassroom,
          icon: 'fa-chalkboard-user',
          color: 'linear-gradient(135deg, #1e1b4b, #4338ca)',
          active: true
        },
        {
          id: 'p_sma_2',
          title: 'Data Center & Network Operations',
          caption: 'Secure server infrastructure powering institute databases, e-library, and LMS portal.',
          image: imgHeroTraining,
          icon: 'fa-server',
          color: 'linear-gradient(135deg, #312e81, #6366f1)',
          active: true
        }
      ]
    },
    {
      id: 'f_mess',
      name: 'Student Mess & Catering',
      category: 'Student Dining',
      tagline: 'Subsidized, nutritious 3-course daily meals for all residential trainees.',
      description: 'A subsidized, hygienically monitored mess providing wholesome breakfast, lunch, and dinner to residential trainees every day with balanced nutrition and structured weekly menus.',
      icon: 'fa-bowl-rice',
      themeClass: 'theme-mess',
      status: 'Subsidized',
      operatingHours: 'Daily: 7:00 AM – 9:00 PM',
      tags: ['3 Meals Daily', '400+ Trainees', '100% Halal', '7 Days / Week'],
      photos: [
        {
          id: 'p_mes_1',
          title: 'Mess Hall & Serving Line',
          caption: 'Hygienic buffet line serving hot, fresh meals to trainees.',
          image: imgHeroCampus,
          icon: 'fa-bowl-rice',
          color: 'linear-gradient(135deg, #4c1d95, #7c3aed)',
          active: true
        }
      ]
    },
    {
      id: 'f_hostel',
      name: 'Hostels & Officer Lodging',
      category: 'Residential Accommodation',
      tagline: 'Secure, comfortable furnished rooms with 24/7 security and power backup.',
      description: 'Comfortable, secure on-campus residential hostels providing single and shared furnished rooms for local and international aviation trainees with 24/7 security, standby generator power backup, and laundry services.',
      icon: 'fa-building',
      themeClass: 'theme-hostel',
      status: '200+ Beds',
      operatingHours: 'Open 24 Hours / 7 Days',
      tags: ['200+ Rooms', '24/7 Security', 'Generator Backup', 'Laundry Services'],
      photos: [
        {
          id: 'p_hos_1',
          title: 'Student Residence Block',
          caption: 'Modern residential hostel wing set within peaceful campus gardens.',
          image: imgCampusAerial,
          icon: 'fa-building',
          color: 'linear-gradient(135deg, #064e3b, #059669)',
          active: true
        },
        {
          id: 'p_hos_2',
          title: 'Trainee Room Interior',
          caption: 'Furnished room equipped with study desk, wardrobe, bed, and high-speed Wi-Fi.',
          image: imgGalleryClassroom,
          icon: 'fa-bed',
          color: 'linear-gradient(135deg, #047857, #10b981)',
          active: true
        }
      ]
    }
  ],
  quickLinks: [
    {
      id: "ql_1",
      title: "Annual Training Plan (ATP 2026)",
      link: "https://docs.google.com/document/d/1VKH88h75Qd2hE34wgFTafqQiw4wKlL-5/edit",
      file: "Annual_Training_Plan_2026.pdf",
      fileType: "pdf",
      numbering: 1,
      isActive: true
    },
    {
      id: "ql_2",
      title: "CPD Portal Login",
      link: "https://cati-lms.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 2,
      isActive: true
    },
    {
      id: "ql_3",
      title: "Pakistan Airports Authority (PAA)",
      link: "https://paa.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 3,
      isActive: true
    },
    {
      id: "ql_4",
      title: "CATI LMS Portal",
      link: "https://cati-lms.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 4,
      isActive: true
    },
    {
      id: "ql_5",
      title: "CATI E-Library",
      link: "https://cati-elibrary.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 5,
      isActive: true
    }
  ],
  usefulLinks: [
    {
      id: "ql_1",
      title: "Annual Training Plan (ATP 2026)",
      link: "https://docs.google.com/document/d/1VKH88h75Qd2hE34wgFTafqQiw4wKlL-5/edit",
      file: "Annual_Training_Plan_2026.pdf",
      fileType: "pdf",
      numbering: 1,
      isActive: true
    },
    {
      id: "ql_2",
      title: "CPD Portal Login",
      link: "https://cati-lms.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 2,
      isActive: true
    },
    {
      id: "ql_3",
      title: "Pakistan Airports Authority (PAA)",
      link: "https://paa.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 3,
      isActive: true
    },
    {
      id: "ql_4",
      title: "CATI LMS Portal",
      link: "https://cati-lms.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 4,
      isActive: true
    },
    {
      id: "ql_5",
      title: "CATI E-Library",
      link: "https://cati-elibrary.pitb.gov.pk/",
      file: null,
      fileType: "link",
      numbering: 5,
      isActive: true
    }
  ]
};

/* ---------- STORAGE & CLOUD SYNC HELPERS ---------- */
const CLOUD_CONFIG_KEY = 'cati_cloud_sync_config';

const syncChannel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('cati_cms_sync') : null;
if (syncChannel) {
  syncChannel.onmessage = (event) => {
    if (event.data && event.data.type === 'DATA_UPDATED') {
      if (event.data.store) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(event.data.store));
      }
      window.dispatchEvent(new CustomEvent('cati-data-synced', { detail: event.data.store }));
    }
  };
}

export const CLOUD_SYNC_STATUS = {
  lastSync: null,
  status: 'idle', // 'idle' | 'syncing' | 'synced' | 'error' | 'disabled'
  message: ''
};

function notifySyncStatus() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('cati-cloud-status-changed', { detail: { ...CLOUD_SYNC_STATUS } }));
  }
}

export function getCloudConfig() {
  try {
    const saved = localStorage.getItem(CLOUD_CONFIG_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {}
  return {
    enabled: true,
    provider: 'rest',
    endpointUrl: (typeof localStorage !== 'undefined' && localStorage.getItem('cati_cloud_endpoint_url')) || '',
    apiKey: (typeof localStorage !== 'undefined' && localStorage.getItem('cati_cloud_api_key')) || ''
  };
}

export function saveCloudConfig(config) {
  try {
    localStorage.setItem(CLOUD_CONFIG_KEY, JSON.stringify(config));
    if (config.endpointUrl !== undefined) localStorage.setItem('cati_cloud_endpoint_url', config.endpointUrl);
    if (config.apiKey !== undefined) localStorage.setItem('cati_cloud_api_key', config.apiKey);
  } catch (e) {}
  window.dispatchEvent(new CustomEvent('cati-cloud-config-changed', { detail: config }));
  fetchCloudStore();
}

function loadStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

function saveStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (e) {
    console.error('Failed to save to localStorage', e);
  }
}

function getEffectiveEndpointUrl(config) {
  if (config && config.endpointUrl) return config.endpointUrl;
  return './api/data.php';
}

export async function fetchCloudStore() {
  const config = getCloudConfig();
  if (!config || config.enabled === false) {
    CLOUD_SYNC_STATUS.status = 'disabled';
    CLOUD_SYNC_STATUS.message = 'Cloud sync disabled';
    notifySyncStatus();
    return null;
  }

  const url = getEffectiveEndpointUrl(config);

  try {
    CLOUD_SYNC_STATUS.status = 'syncing';
    CLOUD_SYNC_STATUS.message = 'Syncing server data...';
    notifySyncStatus();

    const headers = { 'Accept': 'application/json' };
    if (config.apiKey) {
      headers['X-Master-Key'] = config.apiKey;
      headers['Authorization'] = `Bearer ${config.apiKey}`;
    }

    const response = await fetch(url, { method: 'GET', headers });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} ${response.statusText}`);
    }

    let remoteData = await response.json();
    if (remoteData && remoteData.record) {
      remoteData = remoteData.record;
    }

    if (remoteData && typeof remoteData === 'object' && Object.keys(remoteData).length > 0) {
      saveStore(remoteData);
      CLOUD_SYNC_STATUS.status = 'synced';
      CLOUD_SYNC_STATUS.lastSync = new Date().toISOString();
      CLOUD_SYNC_STATUS.message = 'Synced with Live Server Data';
      notifySyncStatus();

      if (syncChannel) {
        syncChannel.postMessage({ type: 'DATA_UPDATED', store: remoteData });
      }
      window.dispatchEvent(new CustomEvent('cati-data-synced', { detail: remoteData }));
      return remoteData;
    }
  } catch (err) {
    console.warn('Server sync notice:', err.message);
    CLOUD_SYNC_STATUS.status = 'idle';
    CLOUD_SYNC_STATUS.message = 'Local Mode (Local storage active)';
    notifySyncStatus();
  }
  return null;
}

export async function pushCloudStore(store) {
  const currentStore = store || loadStore();

  if (syncChannel) {
    syncChannel.postMessage({ type: 'DATA_UPDATED', store: currentStore });
  }

  const config = getCloudConfig();
  if (!config || config.enabled === false) return false;

  const url = getEffectiveEndpointUrl(config);

  try {
    CLOUD_SYNC_STATUS.status = 'syncing';
    CLOUD_SYNC_STATUS.message = 'Publishing changes to server...';
    notifySyncStatus();

    const headers = { 'Content-Type': 'application/json' };
    if (config.apiKey) {
      headers['X-Master-Key'] = config.apiKey;
      headers['Authorization'] = `Bearer ${config.apiKey}`;
    }

    const fullPayload = exportAll();
    const isJsonBin = url.includes('jsonbin.io');
    const method = isJsonBin ? 'PUT' : (config.httpMethod || 'POST');

    let response = await fetch(url, {
      method: method,
      headers,
      body: JSON.stringify(fullPayload)
    });

    if (!response.ok && method === 'PUT') {
      response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(fullPayload)
      });
    }

    if (response.ok) {
      CLOUD_SYNC_STATUS.status = 'synced';
      CLOUD_SYNC_STATUS.lastSync = new Date().toISOString();
      CLOUD_SYNC_STATUS.message = 'Server Data Sync Complete!';
      notifySyncStatus();
      return true;
    } else {
      throw new Error(`HTTP ${response.status}`);
    }
  } catch (err) {
    console.warn('Server push notice:', err.message);
    CLOUD_SYNC_STATUS.status = 'idle';
    CLOUD_SYNC_STATUS.message = 'Saved locally';
    notifySyncStatus();
    return false;
  }
}

export function initCloudSync() {
  fetchCloudStore();
}

if (typeof window !== 'undefined') {
  setTimeout(initCloudSync, 150);
}

/* ---------- PUBLIC API ---------- */
export function getData(section) {
  const store = loadStore();
  if (section === 'quickLinks' || section === 'usefulLinks') {
    const list = store.quickLinks || store.usefulLinks || DEFAULTS.quickLinks;
    if (Array.isArray(list) && list.length > 0) return list;
    if (DEFAULTS.quickLinks) return JSON.parse(JSON.stringify(DEFAULTS.quickLinks));
  }
  if (store[section] !== undefined && store[section] !== null) {
    if (Array.isArray(store[section]) && store[section].length === 0 && DEFAULTS[section] && DEFAULTS[section].length > 0) {
      return JSON.parse(JSON.stringify(DEFAULTS[section]));
    }
    if (section === 'courses' && Array.isArray(store[section]) && DEFAULTS.courses) {
      const defaultMap = new Map(DEFAULTS.courses.map(c => [c.id, c]));
      store[section].forEach(course => {
        const def = defaultMap.get(course.id);
        if (def && (!course.startDate || course.startDate.startsWith('2025-08-03'))) {
          course.startDate = def.startDate;
          course.endDate = def.endDate;
        }
      });
    }
    return store[section];
  }
  if (DEFAULTS[section] !== undefined) return JSON.parse(JSON.stringify(DEFAULTS[section]));
  return null;
}

export function setData(section, data) {
  const store = loadStore();
  store[section] = data;
  if (section === 'quickLinks') store['usefulLinks'] = data;
  if (section === 'usefulLinks') store['quickLinks'] = data;
  saveStore(store);
  pushCloudStore(store);
}

export function resetData(section) {
  const store = loadStore();
  delete store[section];
  saveStore(store);
  pushCloudStore(store);
}

export function resetAll() {
  localStorage.removeItem(STORAGE_KEY);
  pushCloudStore({});
}

export function exportAll() {
  const store = loadStore();
  const full = {};
  for (const key of Object.keys(DEFAULTS)) {
    full[key] = store[key] !== undefined ? store[key] : JSON.parse(JSON.stringify(DEFAULTS[key]));
  }
  return full;
}

export function importAll(data) {
  saveStore(data);
  pushCloudStore(data);
}

export function getDefaults(section) {
  return JSON.parse(JSON.stringify(DEFAULTS[section]));
}

export function generateId(prefix = 'id') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
}

export function logActivity(action, details) {
  try {
    const logs = getData('auditLogs') || [];
    logs.unshift({
      timestamp: new Date().toISOString(),
      action: action,
      details: details
    });
    if (logs.length > 100) logs.pop();
    setData('auditLogs', logs);
  } catch (e) {
    console.error('Failed to record audit log entry', e);
  }
}